var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPushLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5ZM6.75 7V17C6.75 17.4142 6.41421 17.75 6 17.75C5.58579 17.75 5.25 17.4142 5.25 17V7C5.25 6.58579 5.58579 6.25 6 6.25C6.41421 6.25 6.75 6.58579 6.75 7ZM12.864 8.78658L10.3415 11.25H18C18.4142 11.25 18.75 11.5858 18.75 12C18.75 12.4142 18.4142 12.75 18 12.75H10.3415L12.864 15.2134C13.1604 15.5028 13.166 15.9777 12.8766 16.274C12.5872 16.5704 12.1123 16.576 11.816 16.2866L7.976 12.5366C7.83148 12.3955 7.75 12.202 7.75 12C7.75 11.798 7.83148 11.6045 7.976 11.4634L11.816 7.71342C12.1123 7.42402 12.5872 7.42965 12.8766 7.726C13.166 8.02234 13.1604 8.49718 12.864 8.78658Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushLeft);
export default __webpack_public_path__ + "static/media/push-left.c4c83d03f1fc32fefeb8e9f3ed331014.svg";
export { ForwardRef as ReactComponent };